/* 描述「See more」—— 只在内容确实溢出时才加按钮。
   为什么不在 Liquid 里判断：Liquid 拿不到渲染后的高度，只能按字数猜，
   而同样字数在窄屏和宽屏的行数完全不同。所以放到浏览器里量。 */
(function () {
  function setup(el) {
    if (el.dataset.clampReady) return;
    // 0 行 = 不截断
    var lines = parseInt(getComputedStyle(el).getPropertyValue('--fitiny-clamp-lines'), 10);
    if (!lines) { el.classList.remove('fitiny-clamp'); return; }
    // scrollHeight > clientHeight 就是被截断了
    if (el.scrollHeight <= el.clientHeight + 2) {
      el.classList.remove('fitiny-clamp');   // 没溢出就别留着渐隐层
      el.dataset.clampReady = '1';
      return;
    }
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'fitiny-seemore';
    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-controls', el.id || '');
    btn.textContent = el.dataset.more || 'See more';
    btn.addEventListener('click', function () {
      var open = el.classList.toggle('is-expanded');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.textContent = open ? (el.dataset.less || 'See less') : (el.dataset.more || 'See more');
    });
    el.insertAdjacentElement('afterend', btn);
    el.dataset.clampReady = '1';
  }
  function run() { document.querySelectorAll('.fitiny-clamp').forEach(setup); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  // 变体切换会重渲染右栏，Dawn 派发这个事件
  document.addEventListener('variant:change', run);
})();
